import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import ApiService from './apiService';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export const ClubServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: '/bin/lt/club.ef',
	headers: {
		'Content-Type': 'application/json; charset=UTF-8'
	}
});

export default class ClubService extends ApiService implements ltFramework.IClubService {
	constructor() {
		super('club-service', ClubServiceAxiosInstance);
	}

	public getClubs(): AxiosPromise<ltFramework.IClub[]> {
		return this.axiosInstance.get('');
	}

	public getClubsHeader(): AxiosPromise {
		return this.axiosInstance.head('');
	}

	public getClubById(clubId: number): AxiosPromise<ltFramework.IClub[]> {
		return this.axiosInstance.get(`?cId=${clubId}`);
	}
}

export const clubService = new ClubService();
